var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 139,
    viewBox: "0 0 178 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_294",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 178,
    height: 139
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.903 0.435486H0.0967742V138.565H177.903V0.435486Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.801 120.408C100.77 123.758 92.9006 125.633 84.5933 125.633C54.7584 125.633 30.5725 101.448 30.5725 71.6127C30.5725 41.7779 54.7584 17.5919 84.5933 17.5919C114.428 17.5919 138.614 41.7779 138.614 71.6127C138.614 75.1429 138.275 78.594 137.629 81.9354",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.571 107.156L110.485 106.319C112.012 106.102 113.733 105.935 114.942 106.893C115.865 107.626 116.244 108.85 116.402 110.018C116.559 111.186 116.548 112.39 116.913 113.511C117.279 114.631 118.145 115.698 119.315 115.846C120.252 115.964 121.147 115.482 121.975 115.028C122.802 114.575 123.675 114.122 124.618 114.101C125.561 114.079 126.587 114.628 126.789 115.549C127.029 116.644 126.087 117.604 125.265 118.367C124.264 119.296 123.296 120.316 122.769 121.576C122.166 123.015 122.192 124.624 122.064 126.179C121.936 127.733 121.586 129.387 120.45 130.456",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.835 95.1634C123.814 95.5582 123.422 95.8278 123.047 95.7037C122.284 95.4512 121.502 95.2683 120.697 95.2302C119.631 95.1797 118.487 95.525 117.836 96.371C117.371 96.974 117.206 97.7959 117.4 98.5318C117.689 99.6297 118.693 100.404 119.748 100.826C120.802 101.248 121.944 101.399 123.025 101.747C124.105 102.095 125.183 102.701 125.693 103.716C125.996 104.32 126.072 105.017 126.362 105.627C127.08 107.136 128.929 107.759 130.599 107.781C131.711 107.796 132.861 107.6 133.784 106.981C134.761 106.326 135.402 105.241 135.663 104.095C135.925 102.948 135.833 101.744 135.562 100.6C134.837 97.5325 132.87 94.8288 132.412 91.7104C132.179 90.1219 132.305 88.3487 130.746 87.3164C130.072 86.8699 129.242 86.7137 128.442 86.8335C126.448 87.1322 125.115 88.7979 124.501 90.6012C124.005 92.0587 123.918 93.6187 123.835 95.156C123.835 95.1585 123.835 95.1609 123.835 95.1634Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.054 85.8064C143.634 86.3126 142.909 86.4404 142.251 86.4207C141.594 86.401 140.929 86.2694 140.284 86.3964C139.512 86.5481 138.827 87.0868 138.498 87.8007C138.169 88.5145 138.203 89.3853 138.589 90.0706C139.205 91.1659 140.516 91.6291 141.72 91.9904C142.923 92.3516 144.237 92.7754 144.906 93.8396C145.291 94.4532 145.402 95.1977 145.698 95.859C146.328 97.266 147.776 98.185 149.286 98.4995C150.795 98.814 152.366 98.5996 153.867 98.2481",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.787 133.827C145.364 133.827 157.181 122.01 157.181 107.432C157.181 92.8549 145.364 81.0376 130.787 81.0376C116.209 81.0376 104.392 92.8549 104.392 107.432C104.392 122.01 116.209 133.827 130.787 133.827Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.129 129.792C141.915 129.033 140.69 128.265 139.669 127.26C138.648 126.256 137.834 124.981 137.637 123.562C137.546 122.909 137.587 122.242 137.492 121.59C137.398 120.937 137.137 120.265 136.595 119.889C135.475 120.015 134.352 118.841 134.049 117.755C133.747 116.669 134.332 115.406 135.356 114.935C136.313 114.495 137.426 114.725 138.479 114.679C140.187 114.605 141.77 113.787 143.215 112.874C144.66 111.96 146.05 110.922 147.648 110.316C149.247 109.71 151.144 109.597 152.591 110.508C153.43 111.036 154.04 111.853 154.617 112.66C155.146 113.401 155.664 114.15 156.171 114.907",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3203 42.314L84.5996 34.1452L103.659 42.314C103.659 42.314 104.606 58.2525 102.045 64.642C99.4844 71.0315 84.5996 81.3063 84.5996 81.3063C84.5996 81.3063 66.954 70.8503 66.0827 61.5923C65.2114 52.3343 65.3203 42.314 65.3203 42.314Z",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9158 100.122C90.9158 100.122 86.7622 85.8631 100.112 83.1082L106.149 74.6124C107.241 73.0764 109.354 72.6824 110.925 73.7219C112.515 74.7731 113.504 76.8665 112.481 78.4745L105.217 89.0939",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.89 77.0858V62.5108C112.89 60.2777 114.7 58.4673 116.933 58.4673C119.167 58.4673 120.977 60.2777 120.977 62.5108V79.5505C120.977 80.6969 120.648 81.8191 120.028 82.7835",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.83 109.08H90.5368C89.6508 109.08 88.9325 108.362 88.9325 107.476V101.726C88.9325 100.84 89.6508 100.122 90.5368 100.122H105.183",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2707 100.122C78.2707 100.122 82.4243 85.8631 69.0745 83.1082L63.0372 74.6124C61.9456 73.0764 59.8328 72.6824 58.261 73.7219C56.6716 74.7731 55.6825 76.8665 56.705 78.4745L63.9693 89.0939",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2966 77.0858V62.5108C56.2966 60.2777 54.4862 58.4673 52.2531 58.4673C50.0199 58.4673 48.2095 60.2777 48.2095 62.5108V79.5505C48.2095 80.6969 48.539 81.8191 49.1586 82.7835L60.2993 100.122",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.515 109.08H78.6497C79.5358 109.08 80.254 108.362 80.254 107.476V101.726C80.254 100.84 79.5358 100.122 78.6497 100.122H60.515C59.6289 100.122 58.9106 100.84 58.9106 101.726V107.476C58.9106 108.362 59.6289 109.08 60.515 109.08Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5388 54.5618L81.0851 60.4421L92.1171 49.557",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04);
export default __webpack_public_path__ + "static/media/icon04.11fc6fd3f8b747e0e8b125f9c4832741.svg";
export { ForwardRef as ReactComponent };